var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAsync } from "@iscr/xAppLib/Hooks/useAsync";
import API_service from "@iscr/xAppLib/providers/API_service";
import { ConfigurableCarouselCard } from "@iscr/contentful/components/InfoCards/ConfigurableCarouselCard";
import { contentfulToCTA, contentfulToImageData } from "@iscr/contentful/functions/functions";
import { getContentBlockStyling } from "@iscr/contentful/functions/contentBlockStyling";
import { CTAWrapper } from "@iscr/contentful/components/CTA";
import { formatRichText } from "@iscr/contentful/functions/richText";
const MAXIMUM_RELATED_POSTS = 3;
const CTACardDetails = ({ header, subtitle, ctas, }) => {
    return (_jsxs("div", { className: "flex flex-col justify-between gap-1 py-1 px-6 h-full", children: [_jsx("h3", { className: "text-lg text-white font-bold", children: header }), _jsx("p", { className: "text-white text-sm", children: subtitle }), ctas && ctas.length > 0 && (_jsx("div", { className: "mt-4", children: ctas.map((cta, index) => (_jsx(CTAWrapper, { cta: cta }, index))) }))] }));
};
export const CallToActionCards = ({ advertisements }) => {
    const { callToActionCards, loading } = useCallToActionCards(advertisements);
    if (loading || !callToActionCards) {
        return null;
    }
    return (_jsx("div", { className: "flex-1 flex flex-col md:flex-row lg:flex-col my-6 mx-auto lg:ml-6 lg:mr-0 gap-4 w-full px-6 lg:px-0", children: callToActionCards === null || callToActionCards === void 0 ? void 0 : callToActionCards.map(({ id, headerText, subtitle, imageUrl, imageAlt, ctas, formattedSectionStyles }) => {
            return (_jsx(ConfigurableCarouselCard, { ctas: ctas, headerText: headerText, subtitle: subtitle, imageUrl: imageUrl, imageAlt: imageAlt, formattedSectionStyles: formattedSectionStyles, cardWidth: {
                    base: "w-full",
                    md: "min-w-[330px]",
                }, wrapperClass: "mx-0", cardFooterComponent: _jsx(CTACardDetails, { header: headerText, subtitle: subtitle, ctas: ctas }) }, id));
        }) }));
};
const formatPostToCard = (cardInfo) => {
    var _a;
    const { headerText, image, cardStyles, content } = cardInfo.fields;
    const imageData = contentfulToImageData(image);
    const cardStyling = getContentBlockStyling(cardStyles, cardInfo.fields.variant);
    const formattedStyling = Object.assign(Object.assign({}, cardStyling), { cardStyling: {
            backgroundColor: "bg-is2-blue",
        } });
    return {
        id: cardInfo.sys.id,
        headerText: headerText,
        imageUrl: imageData === null || imageData === void 0 ? void 0 : imageData.imageUrl,
        imageAlt: (imageData === null || imageData === void 0 ? void 0 : imageData.description) || "Related cardInfo image",
        cardVariant: "default",
        formattedSectionStyles: formattedStyling,
        subtitle: formatRichText(content || "", (_a = (globalThis._appppa || globalThis.app)) === null || _a === void 0 ? void 0 : _a.site_status),
        ctas: cardInfo.fields.ctas.map((cta) => contentfulToCTA(cta)) || [],
    };
};
const useCallToActionCards = (advertisements) => {
    const { data: { callToActionCards } = {}, loading } = useAsync(() => __awaiter(void 0, void 0, void 0, function* () {
        if (advertisements === null || advertisements === void 0 ? void 0 : advertisements.length)
            return { callToActionCards: advertisements.map(formatPostToCard) };
        try {
            const response = yield API_service.load_data("cms/getEntries", {
                content_type: "infoCard",
                content_tags: ["ctaCard"],
                order: ["-sys.publishedAt"],
                pagination: {
                    limit: MAXIMUM_RELATED_POSTS,
                    skip: 0,
                },
                preview: true,
            });
            if (response.status === "ok") {
                const callToActionCards = response.entries.items.map((cardInfo) => formatPostToCard(cardInfo));
                return { callToActionCards };
            }
            else {
                console.error("Failed to fetch call to action cards:", response);
                return { callToActionCards: [] };
            }
        }
        catch (error) {
            console.error("Error fetching call to action cards:", error);
            return { callToActionCards: [] };
        }
    }), [advertisements]);
    return { callToActionCards, loading };
};
